module.exports = __webpack_public_path__ + "img/testimonial_bottom.0e79c084.png";